<div ref="mapContainer" id="{{ctx.instance.id}}-map" class="{{ctx.ofPrefix}}leaflet-map"></div>
